import { Component, OnDestroy, OnInit } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { MomentDateAdapter } from "@angular/material-moment-adapter"
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core"
import { ActivatedRoute } from '@angular/router'
import { Subscription } from "rxjs"
import { AuthenticationService } from "../../../access/shared/authentication/authentication.service"
import { NotificationService } from "../../../notification/shared/notification.service"
import { CUSTOM_DATE_FORMAT } from '../../shared/datepicker/datepicker-format'
import { StatsService } from "../shared/stats/stats.service"

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' }
  ],
})
export class ExportComponent implements OnInit, OnDestroy {

  select: string = "c"
  active: string = ""
  exportOkCab: boolean = false
  canExportCurrent: boolean = false
  canExportCurrentAndCS: boolean = false
  rangePicker: boolean = false
  canExportAll: boolean = false
  canCheckOkCab: boolean = false
  user: number
  load: Subscription = new Subscription()

  loading: boolean = false

  selectOptions: { value: string, view: string }[]
  selectedValue: string
  typesConso: { value: string, view: string }[]
  seletedTypeConso: string

  consoHistoryForm: UntypedFormGroup

  constructor(private statsService: StatsService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private notificationService: NotificationService) {
  }

  ngOnInit() {
    this.route.parent.data.subscribe(data => {
      this.active = data.stats
      this.canExportCurrent = data.canExportCurrent
      this.canExportCurrentAndCS = data.canExportCurrentAndCS
      this.canExportAll = data.canExportAll
      this.canCheckOkCab = data.canCheckOkCab ? data.canCheckOkCab : undefined
      this.selectOptions = data.selectOptions ? data.selectOptions : undefined
      this.typesConso = data.typesConso ? data.typesConso : undefined
      this.rangePicker = data.rangePicker ? data.rangePicker : false

      if (data.typesConso && data.selectedValue) {
        this.consoHistoryForm = new UntypedFormGroup({
          'dateMin': new UntypedFormControl(null, [Validators.required]),
          'dateMax': new UntypedFormControl(null, [Validators.required]),
          'typeConso': new UntypedFormControl(data.seletedTypeConso, [Validators.required]),
          'typeAffichage': new UntypedFormControl(data.selectedValue, [Validators.required]),
        })
      }
    })
  }

  ngOnDestroy() {
    this.load.unsubscribe()
  }

  export() {
    this.loading = true
    this.load.unsubscribe()
    if (this.active == 'linge-hebergement') {
      this.notificationService.notif("Pas d'export possible", 'notif')
    } else if (this.select == 'c' || ['5-last-cleaning', 'cab-db-integrity', 'conso-history'].includes(this.active)) {
      let params = {}
      if (this.exportOkCab) {
        params = {
          'exportOkCab': this.exportOkCab
        }
      }
      if (this.consoHistoryForm) {
        params = {
          'dateMin': this.consoHistoryForm.controls.dateMin.value.format('YYYY-MM-DD'),
          'dateMax': this.consoHistoryForm.controls.dateMax.value.format('YYYY-MM-DD'),
          'typeConso': this.consoHistoryForm.controls.typeConso.value,
          'typeAffichage': this.consoHistoryForm.controls.typeAffichage.value,
        }
      }
      this.load = this.statsService.exportOfCurrentClient(this.active, this.select, params).subscribe(response => this.loading = false, error => this.loading = false)
    } else {
      if (this.active == "porteur") {
        this.load = this.statsService.downloadStatsOfClient(this.active, this.select).subscribe(res => {
          this.loading = false
          this.notificationService.notif(res, 'notif')
        }, error => this.loading = false)
      } else {
        if (this.select == "all") {
          this.load = this.statsService.exportAll(this.authenticationService.getUserToken().id, this.active).subscribe(response => this.loading = false, error => this.loading = false)
        } else {
          this.load = this.statsService.exportOfCurrentClient(this.active, this.select, {}).subscribe(response => this.loading = false, error => this.loading = false)
        }
      }
    }
  }

}
